$(function () {
    $('.candidate').on('click', function() {
        window.location.href = $(this).data('url')
    })
})


// WEBPACK FOOTER //
// ./resources/assets/js/components/candidate-tile.js